import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["menu", "backdrop"]

    open() {
        // Prevent body scroll
        document.body.style.overflow = "hidden"

        // Show backdrop
        this.backdropTarget.style.display = "block"
        this.backdropTarget.offsetHeight
        this.backdropTarget.classList.remove("opacity-0")
        this.backdropTarget.classList.add("opacity-100")

        // Show menu
        this.menuTarget.style.display = "block"
        this.menuTarget.offsetHeight
        this.menuTarget.classList.remove("opacity-0", "translate-x-full")
        this.menuTarget.classList.add("opacity-100", "translate-x-0")
    }

    close() {
        // Restore body scroll
        document.body.style.overflow = ""

        // Hide menu
        this.menuTarget.classList.add("opacity-0", "translate-x-full")
        this.menuTarget.classList.remove("opacity-100", "translate-x-0")

        // Hide backdrop
        this.backdropTarget.classList.add("opacity-0")
        this.backdropTarget.classList.remove("opacity-100")

        // Clean up after animation
        setTimeout(() => {
            this.menuTarget.style.display = "none"
            this.backdropTarget.style.display = "none"
        }, 200)
    }

    closeOnLinkClick(event) {
        // Close the menu when a navigation link is clicked
        this.close()

        // Allow the default link behavior to continue
        // The smooth scrolling will be handled by the application layout script
    }
} 